import axios from "axios";
const API_BASE_URL = "https://api.starmarketapi.online/processing_plant_list"



const apiClient = axios.create({
  baseURL:"https://api.starmarketapi.online/processing_plant_list", // Add your base URL here

  timeout: 5000, // Set a timeout if needed
  headers: {
    "Content-Type": "application/json",
  },
});
const REFRESH_TOKEN_URL = `${API_BASE_URL}/refresh`;
// Tokens state
let accessToken = null;
let refreshToken = null;

// Function to set tokens (call this after login)
export const setTokens = (newAccessToken, newRefreshToken) => {
  accessToken = newAccessToken;
  refreshToken = newRefreshToken;
};

// Add interceptors to handle request or response if needed
apiClient.interceptors.request.use(
  (config) => {
    accessToken = localStorage.getItem("accessToken")
    // Add authorization token or modify config if necessary
    if (accessToken) {
      config.headers = config.headers || {}; // Ensure headers object exists
      config.headers["Authorization"] = `Bearer ${accessToken}`;
      console.log("after authorization")
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    refreshToken = localStorage.getItem("refreshToken")
    // If access token is expired, try to refresh it
    if (
      error.response &&
      error.response.status === 401 &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      try {
        // Call refresh token endpoint
        const refreshResponse = await axios.post(REFRESH_TOKEN_URL, {
          refreshToken,
        });
        accessToken = refreshResponse.data.accessToken;
        refreshToken = refreshResponse.data.refreshToken;
        localStorage.setItem("accessToken", accessToken);
        localStorage.setItem("refreshToken", refreshToken);

        // Update Axios Authorization header
        apiClient.defaults.headers["Authorization"] = `Bearer ${accessToken}`;
        originalRequest.headers["Authorization"] = `Bearer ${accessToken}`;
        console.log("refresh token is working");
        // Retry the original request with new token
        return apiClient(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        // Optionally, redirect to login page if refresh fails
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
